/* tslint:disable */
/* eslint-disable */
/**
 * Retool API
 * The Retool API is in beta. Go to Settings > API to get started. Once you generate an API token, use bearer token authentication to make requests.
 *
 * The version of the OpenAPI document: 2.4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Custom Component Library
 * @export
 * @interface CustomComponentLibrariesLibraryIdGet200ResponseData
 */
export interface CustomComponentLibrariesLibraryIdGet200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof CustomComponentLibrariesLibraryIdGet200ResponseData
     */
    id: string;
    /**
     * How the library will be referred to in Toolscript, and other code based usages.
     * @type {string}
     * @memberof CustomComponentLibrariesLibraryIdGet200ResponseData
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CustomComponentLibrariesLibraryIdGet200ResponseData
     */
    description: string | null;
    /**
     * How the library will be referred to in the Retool UI. Should be human readable.
     * @type {string}
     * @memberof CustomComponentLibrariesLibraryIdGet200ResponseData
     */
    label: string;
    /**
     * 
     * @type {Date}
     * @memberof CustomComponentLibrariesLibraryIdGet200ResponseData
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CustomComponentLibrariesLibraryIdGet200ResponseData
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the CustomComponentLibrariesLibraryIdGet200ResponseData interface.
 */
export function instanceOfCustomComponentLibrariesLibraryIdGet200ResponseData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

export function CustomComponentLibrariesLibraryIdGet200ResponseDataFromJSON(json: any): CustomComponentLibrariesLibraryIdGet200ResponseData {
    return CustomComponentLibrariesLibraryIdGet200ResponseDataFromJSONTyped(json, false);
}

export function CustomComponentLibrariesLibraryIdGet200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomComponentLibrariesLibraryIdGet200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'label': json['label'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

export function CustomComponentLibrariesLibraryIdGet200ResponseDataToJSON(value?: CustomComponentLibrariesLibraryIdGet200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'label': value.label,
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
    };
}

